/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteFenceResultByGuid$Params {
  raceGuid: string;
  riderGuid: string;
}

export function deleteFenceResultByGuid(http: HttpClient, rootUrl: string, params: DeleteFenceResultByGuid$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteFenceResultByGuid.PATH, 'delete');
  if (params) {
    rb.path('raceGuid', params.raceGuid, {"style":"simple"});
    rb.path('riderGuid', params.riderGuid, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteFenceResultByGuid.PATH = '/races/{raceGuid}/riders/{riderGuid}/fenceresults';
